import {
  Grid,
  makeStyles,
  createStyles,
  Theme,
  Typography,
  ButtonBase,
} from '@material-ui/core';
import { colors } from 'design-system';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    errorContainer: {
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(4),
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
    errorImage: {
      marginTop: 20,
      marginBottom: 20,
    },
    errorTitle: {
      fontSize: '13px',
      fontWeight: 900,
      lineHeight: '15px',
      marginBottom: '10px',
    },
    errorDescription: {
      fontSize: '11px',
      lineHeight: '13px',
      fontWeight: 400,
      color: colors.abbey,
    },
    whatsapp: {
      color: colors.bright_turquoise,
      verticalAlign: 'bottom',
    },
    email: {
      color: colors.bright_turquoise,
      textDecoration: 'none',
    },
    textSpace: {
      marginBottom: 30,
    },
  }),
);

const PDFErrorMessage = (): JSX.Element => {
  const classes = useStyles();
  return (
    <div className={classes.errorContainer}>
      <Grid container justifyContent="center">
        <Grid item xs={12} container justifyContent="center">
          <img
            className={classes.errorImage}
            alt="error_server_image"
            src="/svg/error_server_image.svg"
            width={300}
          />
        </Grid>
        <Grid item container xs={12} justifyContent="center">
          <Grid item xs={10} container justifyContent="center">
            <Typography
              variant="caption"
              align="center"
              className={classes.errorTitle}
            >
              Disculpa, no hemos podido cargar el documento. Por favor recarga
              la página para continuar.
            </Typography>
          </Grid>
        </Grid>
        <Grid
          item
          container
          xs={12}
          justifyContent="center"
          className={classes.textSpace}
        >
          <Grid item xs={10} container justifyContent="center">
            <Typography
              variant="caption"
              align="center"
              className={classes.errorDescription}
            >
              <div>
                Si el error persiste, escríbenos al{' '}
                <ButtonBase
                  onClick={(): Window | null =>
                    window.open(`https://wa.me/50625032772`)
                  }
                  id="sales-web-inspection-whatsapp-button"
                  data-testid="whatsapp-button"
                  className={classes.whatsapp}
                  component="span"
                >
                  <strong> WhatsApp (506)2503-2772</strong>
                </ButtonBase>{' '}
                o a soporte técnico:{' '}
                <a
                  data-testid="anchor-email"
                  href="mailto:soporteventasautocr@assanet.com"
                  className={classes.email}
                >
                  <strong>soporteventasautocr@assanet.com</strong>
                </a>
              </div>
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default PDFErrorMessage;
